import useSWR, { Key } from 'swr';
import isFunction from 'lodash/isFunction';

import { requestService } from 'shared/utils/services/requestService';
import { useStoreSelector } from 'store/hooks/storeHooks';

/*
  Helper wrapper around `useSWR` that:
  1) only makes the fetch when the user is authenticated
  2) includes the user's id as part of the swr key
    - this prevents one user from seeing another user's fetched state when switching accounts
  
  Usage is the same as traditional `useSWR` hook but with above benefits
*/

const GET_FETCHER = ({ url }) => requestService({ url, method: 'GET' });

export const useAuthenticatedSwr: typeof useSWR = (...args) => {
  const { isAuthenticated, user } = useStoreSelector((state) => state.auth);
  const [key] = args;

  // Get underlying incoming key
  const incomingKeyValue = isFunction(key) ? key() : key;

  // Unauthenticated default
  let newKey: Key = null;

  // Supply incoming key + userId if authenticated
  if (isAuthenticated) newKey = { url: incomingKeyValue, key: user.id };

  return useSWR(newKey, GET_FETCHER);
};
